/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const extendedEncodeURI = (s: string) =>
  encodeURIComponent(s.replaceAll("%", "%25"));
